import {
  AuditLogResource,
  ListAuditLogsFilterParameterResourceTypeEq
} from "@wingspanhq/wingspan-api-sdk";
import { ResourceHistory } from "../../../shared/components/ResourceHistory";
import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import React from "react";
import { WSQueries } from "../../../query/WSQuery";
import { useQueryPlanEnrollments } from "../../../query/benefits/useQueryPlanEnrollments";
import { useGoToMyResourceDetailsHistory } from "../paths";

type IPlanType = planEnrollmentApiSpec.PlanEnrollment["planType"];

type Props = {
  planType: IPlanType;
  insuranceCoverageId: string;
  isCompactView?: boolean;
};

export const MyResourceInsuranceHistory: React.FC<Props> = ({
  planType,
  isCompactView,
  insuranceCoverageId
}) => {
  const goToMyResourceDetailsHistory = useGoToMyResourceDetailsHistory();

  const qPlanEnrollments = useQueryPlanEnrollments({
    filter: {
      planType
    }
  });

  return (
    <WSQueries queries={{ qPlanEnrollments }}>
      {({ qPlanEnrollmentsData }) => {
        // v1's `PlanEnrollment` is `BenefitEnrollment` on v3 — the audit log
        // knows the resource under the new name only.
        const enrollmentResources: AuditLogResource[] =
          qPlanEnrollmentsData.map(enrollment => ({
            resourceType:
              ListAuditLogsFilterParameterResourceTypeEq.BENEFIT_ENROLLMENT,
            resourceId: enrollment.planEnrollmentId
          }));

        const insuranceCoverageResources: AuditLogResource[] = [
          {
            resourceType:
              ListAuditLogsFilterParameterResourceTypeEq.INSURANCE_COVERAGE,
            resourceId: insuranceCoverageId
          }
        ];

        const resources = [
          ...enrollmentResources,
          ...insuranceCoverageResources
        ];

        return (
          <ResourceHistory
            resources={resources}
            drillDownResourceType={
              ListAuditLogsFilterParameterResourceTypeEq.BENEFIT_ENROLLMENT
            }
            onViewAll={
              isCompactView
                ? () => goToMyResourceDetailsHistory(insuranceCoverageId)
                : undefined
            }
          />
        );
      }}
    </WSQueries>
  );
};
